enum OrderState {
  InProgress = 'InProgress',
  InProgressWithTradeIn = 'InProgressWithTradeIn',
  OrderPlaced = 'OrderPlaced',
  RecentlyPurchased = 'RecentlyPurchased',
  Reserved = 'Reserved',
  None = 'None'
}

export default OrderState;
